<template>
  <RouterLink
    :to="'/' + service"
    class="group flex items-center rounded-md px-2 py-2 text-sm font-medium leading-5 text-secondary-600 transition duration-150 ease-in-out hover:bg-secondary-100 hover:text-secondary-800 focus:bg-secondary-50 focus:text-secondary-800 focus:outline-none"
    :class="{
      'bg-secondary-100 text-secondary-900 focus:bg-secondary-200': shaded,
    }"
  >
    <MenuIcons :service="service" />
    {{ label }}
    <span
      v-if="label === 'Messages' && unreadMessageCount > 0"
      class="ml-auto inline-block rounded-full bg-primary-100 py-0.5 px-3 text-xs font-medium text-primary-600"
    >
      {{ unreadMessageCount }}
    </span>
  </RouterLink>
</template>
<script lang="ts" setup>
import { computed } from "vue";
import { useRouter } from "vue-router";
import MenuIcons from "@/components/menu/menu-icons.vue";

const props = defineProps({
  service: {
    type: String,
    default: "",
  },
  label: {
    type: String,
    default: "",
  },
  unreadMessageCount: {
    type: Number,
    default: 0,
  },
});

const { currentRoute } = useRouter();

const shaded = computed(() =>
  currentRoute.value.path.endsWith(`/${props.service}`),
);
</script>
